export default __webpack_public_path__ + "static/media/closed_end.3cc146c7.jpg";